import { ANALYTICS_EXTERNAL_DATA } from '../constants';

const initialData = { idSupplier: '', idUser: 0 };

type TOutput = {
  idSupplier: string;
  idUser: number;
};

export const getAnalyticsExternalData = (): TOutput => {
  const token = localStorage.getItem(ANALYTICS_EXTERNAL_DATA) || '';

  if (!token) return initialData;

  try {
    const decodedToken = atob(token);
    const tokenData = JSON.parse(decodedToken);

    return tokenData;
  } catch (error) {
    console.error('Decoding error:', error);

    return initialData;
  }
};
